import { sessionStore } from '../../api/session';
import { downloadsStore } from '../../downloads/manager';
import { player } from '../../player/engine';
import { connectDownloadHistory } from './downloadsBridge';
import { connectPlayerHistory } from './playerBridge';
import { historySessions } from './sessionTracker';

let holders = 0;
let disconnect: (() => void) | null = null;

function connect(): () => void {
  let lastUser = sessionKey();
  const offs = [
    connectPlayerHistory(player.events),
    connectDownloadHistory(downloadsStore),
    // A different account never continues the previous account's session.
    sessionStore.subscribe(() => {
      const key = sessionKey();
      if (key !== lastUser) historySessions.clear();
      lastUser = key;
    }),
  ];
  return () => offs.forEach((off) => off());
}

/**
 * Starts recording listening history from the player and the downloads
 * manager. Reference-counted: recording runs while at least one caller holds
 * it, so `useEffect(() => startHistoryLogging(), [])` is safe in any number of
 * components. The returned disposer releases this caller's hold (idempotent).
 */
export function startHistoryLogging(): () => void {
  if (holders++ === 0) disconnect = connect();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--holders === 0) {
      disconnect?.();
      disconnect = null;
    }
  };
}

function sessionKey(): string | null {
  const s = sessionStore.get();
  return s ? `${s.serverUrl}|${s.userId}` : null;
}
